import {
    BindAttribute,
    BindStyleToNumber,
    WebzComponent,
    BindCSSClassToBoolean,
    Click,
    Notifier,
    BindStyle,
} from "@boots-edu/webz";
import html from "./slot.component.html";
import css from "./slot.component.css";
import { CardID } from "../card";

/**
 *  A position/slot on the grid with an identity
 *  @export
 *  @param {number} row The rank of the card (0-13)
 *  @param {number} column The suit of the card "hearts", "spades", "diamonds", "clubs", or "empty"
 *  @param {CardID} card The identity of the card
 */
export class SlotComponent extends WebzComponent {
    clickEvent: Notifier<SlotComponent> = new Notifier();
    @BindStyleToNumber("slot", "gridRowStart")
    private row: number;
    @BindStyleToNumber("slot", "gridColumnStart")
    private column: number;
    @BindAttribute(
        "slot-image",
        "src",
        (card: CardID): string => `assets/cards/${card.toName()}.svg`,
    )
    private card: CardID;
    @BindCSSClassToBoolean("slot", "empty")
    private empty: boolean;
    @BindStyle(
        "slot",
        "boxShadow",
        (color: string) => `0px 0px 5px 6px ${color}`,
    )
    private highlight: string = "transparent";
    constructor(row: number, column: number, card: CardID) {
        super(html, css);
        this.row = row;
        this.column = column;
        this.card = card;
        this.empty = this.card.getSuit() === "empty";
    }

    /**
     *  Calls notifier for card being clicked
     */
    @Click("slot")
    onClick() {
        this.clickEvent.notify(this);
    }
    /**
     *  Gets the row number of this slot
     *  @returns {number} Row #
     */
    getRow(): number {
        return this.row;
    }
    /**
     *  Gets the column number of this slot
     *  @returns {number} Column #
     */
    getColumn(): number {
        return this.column;
    }

    /**
     *  Gets the identity of the card as a CardID object or null if the slot is empty
     *  @returns {CardID | null} Card identity or null
     */
    getID(): CardID | null {
        if (this.empty) {
            return null;
        }
        return this.card;
    }
    /**
     *  Sets highlight to the corresponding highlighted color
     *  @param {string} color Color to highlight the card
     */
    setHighlight(color: string) {
        this.highlight = color;
    }

    /**
     *  Sets the identity of the card to the new identity passed or empty.
     *  @param {CardID | null} newID New identity of card
     */
    setID(newID: CardID | null) {
        if (newID) {
            //not null
            this.card = new CardID(newID.getRank(), newID.getSuit());
            this.empty = false;
        } else {
            this.card = new CardID(0, "empty");
            this.empty = true;
        }
    }
}
